import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "count"]

  animate(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const isUpvote = button.dataset.voteType === "1"

    button.style.pointerEvents = "none"

    // Spring scale-down on the button
    button.style.transition = "transform 0.15s cubic-bezier(0.34, 1.56, 0.64, 1)"
    button.style.transform = "scale(0.88)"

    // Icon bounce with spring overshoot
    const icon = button.querySelector('[data-vote-animation-target="icon"]')
    if (icon) {
      icon.style.transition = "transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1), color 0.2s ease"
      icon.style.transform = "scale(1.3)"
    }

    // Count bump
    const count = button.querySelector('[data-vote-animation-target="count"]')
    if (count) {
      count.style.transition = "transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)"
      count.style.transform = "scale(1.15)"
    }

    // Background flash
    const color = isUpvote ? "rgba(91, 174, 24, 0.15)" : "rgba(183, 28, 28, 0.15)"
    const originalBg = button.style.backgroundColor
    button.style.backgroundColor = color

    // Release spring
    setTimeout(() => {
      button.style.transform = "scale(1)"
      if (icon) icon.style.transform = "scale(1)"
      if (count) count.style.transform = "scale(1)"
    }, 200)

    // Fade background back
    setTimeout(() => {
      button.style.backgroundColor = originalBg
    }, 350)

    // Submit after animation settles
    setTimeout(() => {
      button.style.pointerEvents = "auto"
      button.style.transition = ""
      button.style.transform = ""
      if (icon) { icon.style.transition = ""; icon.style.transform = "" }
      if (count) { count.style.transition = ""; count.style.transform = "" }
      this.submitForm(button)
    }, 400)
  }

  submitForm(button) {
    const form = button.closest("form")
    if (!form) return

    if (typeof form.requestSubmit === "function") {
      try {
        form.requestSubmit(button)
        return
      } catch (_e) {
        // fallback below
      }
    }

    if (typeof Turbo !== "undefined" && Turbo.navigator?.submitForm) {
      Turbo.navigator.submitForm(form)
      return
    }

    form.submit()
  }
}
